import { CheckCircle2, Info, TriangleAlert, X, XCircle } from "lucide-react";
import { cn } from "@/lib/cn";
import type { ToastVariant } from "@/context/ToastContext";

const ICONS: Record<ToastVariant, React.ComponentType<{ className?: string }>> = {
  default: Info,
  success: CheckCircle2,
  warning: TriangleAlert,
  danger: XCircle,
};

const ICON_COLOR: Record<ToastVariant, string> = {
  default: "text-info",
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
};

export function ToastItem({
  title,
  description,
  variant = "default",
  onDismiss,
}: {
  title: string;
  description?: string;
  variant?: ToastVariant;
  onDismiss: () => void;
}) {
  const Icon = ICONS[variant];
  return (
    <div className="animate-in flex w-full max-w-sm items-start gap-3 rounded-lg border border-border bg-card p-4 shadow-lg">
      <Icon className={cn("mt-0.5 size-5 shrink-0", ICON_COLOR[variant])} />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-foreground">{title}</p>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      <button
        onClick={onDismiss}
        className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        <X className="size-3.5" />
        <span className="sr-only">Dismiss</span>
      </button>
    </div>
  );
}
